(function($, undefined) {

	'use strict';
	var changeElementColorInput;

	var changeElementColor = function() {
		var t = $(this);
		var parent = t.closest('.color-change-outer-ctn');
		var label = t.attr('name');
		var value = t.val();

		updateLabel(label, value, 'en', function() {
			updateLabel(label, value, 'fr', function() {
				if (value === 'light') {
					parent.find('.element-color-to-change').removeClass('dark').addClass('light');
				} else if (value === 'dark') {
					parent.find('.element-color-to-change').removeClass('light').addClass('dark');
				}
			});
		});
	};

	var init = function () {
		changeElementColorInput = $('.change-element-color-input');

		changeElementColorInput.change(changeElementColor);

	};

	$(window).on('load', function () {
		init();
	});

	var tools = Fw.component.export('tools', {
		init: init,
	});

})(jQuery);
